module.exports = __webpack_public_path__ + "img/2275121.jpg";